import React from "react";
import FadeInOnView from "../../../../components/FadeInOnView";
import { sectionFourCards } from "../../data";
import {
  SectionFour,
  SectionFourInner,
  SectionFourHeader,
  SectionFourMainText,
  SectionFourSideText,
  SectionFourBottomText,
  SectionFourFrame,
  SectionFourOutline,
  SectionFourCards,
  SectionFourCard,
  SectionFourImage
} from "./styles";

export default function SectionFourComponent() {
  return (
    <SectionFour>
          <SectionFourInner>
            <SectionFourHeader as={FadeInOnView}>
              <SectionFourMainText>
                <strong>SEM ACOMPANHAMENTO</strong> O PACIENTE SE PERDE.
              </SectionFourMainText>

              <SectionFourSideText>
                ORGANIZAÇÃO, AUTONOMIA E CONEXÃO&nbsp; ENTRE PROFISSIONAL E
                PACIENTE TUDO EM UMA ÚNICA PLATAFORMA.
              </SectionFourSideText>
            </SectionFourHeader>

            <SectionFourFrame as={FadeInOnView} delay={120}>
              <SectionFourOutline />
              <SectionFourCards>
                {sectionFourCards.map((card) => (
                  <SectionFourCard key={card.title}>
                    <SectionFourImage src={card.src} alt={card.title} />
                  </SectionFourCard>
                ))}
              </SectionFourCards>
            </SectionFourFrame>

            <SectionFourBottomText as={FadeInOnView} delay={240}>
              <strong>A TRATAZ</strong> CONECTA SEU ATENDIMENTO À ROTINA DO
              PACIENTE.
            </SectionFourBottomText>
          </SectionFourInner>
        </SectionFour>
  );
}
